import { render, staticRenderFns } from "./OtherFees.vue?vue&type=template&id=2f508126&scoped=true"
import script from "./OtherFees.vue?vue&type=script&lang=js"
export * from "./OtherFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f508126",
  null
  
)

export default component.exports